<template>
  <div class="nav-card relative aspect-[5/3] w-full nav-marketing-card" :class="textColorClass">
    <div :qaid="`nav-card-${card.ctaLinks[0].uid}`" class="relative z-10 w-full h-full top-0 left-0 p-2">
      <div
        v-if="card.headline"
        class="nav-card__text text-[22px] font-heading font-bold leading-5"
        v-html="card.headline"
      ></div>
      <a
        v-if="card.ctaLinks[0]"
        class="cover-link nav-card__link nav__menu-item mt-2 flex items-center underline"
        :href="composeLink(card.ctaLinks[0].url)"
        :target="setTarget(card.ctaLinks[0].target)"
        @keydown.prevent.right="rightFunction"
        @keydown.prevent.left="leftFunction"
        @keydown.prevent.down="downFunction"
        @keydown.prevent.up="upFunction"
      >
        <span
          class="nav-card__link-text text-lg font-normal mr-25 leading-none"
          v-html="card.ctaLinks[0].linkName"
        ></span>
        <pdl-icon class="nav-card__link-icon" name="chevron_right"></pdl-icon>
      </a>
    </div>
    <div class="nav-card__image absolute h-full w-full top-0 left-0 z-0 mb-2">
      <img
        v-if="card.images[0]"
        :data-nav-image="imageAsset"
        class="h-full w-full object-cover"
        loading="lazy"
        :alt="card.ctaLinks[0].linkName"
      />
    </div>
  </div>
</template>
<script>
import {Cloudinary, CloudinaryConstants} from '@/utils/image/cloudinary-helpers';
import links from '@/navigation/mixins/links.js';
import {PdlIcon} from '@pedal/pdl-icon';

export default {
  name: 'NavCard',
  components: {
    PdlIcon,
  },
  mixins: [links],
  props: {
    card: {
      type: Object,
      default: () => null,
    },
    rightFunction: {
      type: Function,
      default: () => {},
    },
    leftFunction: {
      type: Function,
      default: () => {},
    },
    upFunction: {
      type: Function,
      default: () => {},
    },
    downFunction: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    textColorClass() {
      return this.card.textColor?.toLowerCase() === 'white' ? 'text-white' : 'text-black';
    },
    imageAsset() {
      const imageTransforms = {
        q: 'auto',
        w: 406,
        dpr: `${window.devicePixelRatio}`,
        ...CloudinaryConstants.DEFAULT_PARAMETERS,
      };
      return this.card.images[0] ? Cloudinary.createAssetUrl(this.card.images[0], imageTransforms) : '';
    },
  },
};
</script>

<style scoped lang="scss">
.nav-card {
  max-width: 500px;
  min-width: 340px;
  background-color: var(--nav-card-background-color, #fff);

  &__link {
    transition: all 0.25s ease-out;

    .nav-card__link-icon {
      transition: transform 0.2s;
      transform: translateX(var(--card-arrow-translate, 0));
    }
  }

  &.text-white {
    --nav-card-gradient: linear-gradient(180deg, rgba(0, 0, 0, 0.42) 67%, rgba(0, 0, 0, 0) 100%);
    --nav-card-background-color: #575757;
  }

  &.text-black {
    --nav-card-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.31) 67%, rgba(255, 255, 255, 0) 100%);
  }

  .cover-link {
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 9;
      box-shadow: 0 4px 6px -2px rgb(0 0 0 / 0), 0 10px 15px -3px rgb(0 0 0 / 0);
      transition: box-shadow 0.24s ease;
    }

    @media (hover: hover) {
      &:hover {
        --card-arrow-translate: 4px;

        &::after {
          box-shadow: 0 4px 6px -2px rgb(0 0 0 / 0.1), 0 10px 15px -3px rgb(0 0 0 / 0.15);
        }
      }
    }
  }

  &__image {
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      z-index: 8;
      background: var(--nav-card-gradient);
    }
  }
}
</style>
